import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { commentKeys } from './queryKeys';
import { useApplicationStore } from 'store/application';
import { createTaskComment } from 'api/comment.service';
import { TComment } from 'components/tasks/Comments/types';

export const useTaskCommentCreateQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: (info: { entityId: string; comment: TComment }) => {
      setLoading();

      return createTaskComment(info.entityId, info.comment);
    },
    onSuccess: () => {
      toast.success('Comment has been created successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: (_comment, _error, info) => {
      queryClient.invalidateQueries({
        queryKey: commentKeys.task(info.entityId),
      });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate, data };
};
